import {Table, TablePredicateProps} from '@components/mantine';
import {type OwnedFile} from '@core/debug';

interface OwnerPredicateProps<OwnedType extends 'frontendOwner' | 'backendOwner'>
    extends Pick<TablePredicateProps, 'classNames' | 'label'> {
    id: OwnedType;
    owners: Array<OwnedFile[OwnedType]>;
}

export const OwnerPredicate = <OwnedType extends 'frontendOwner' | 'backendOwner'>({
    owners,
    ...props
}: OwnerPredicateProps<OwnedType>) => (
    <Table.Predicate
        {...props}
        data={[
            {value: '', label: 'All'},
            ...owners.map((owner) => ({
                value: owner,
                label: owner,
            })),
        ]}
    />
);
